// @ts-nocheck
import {addDays} from 'date-fns'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../_metronic/assets/ts/components'

import {initialQueryState, KTSVG} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {DateRange} from 'react-date-range'
import {useDispatch, useSelector} from 'react-redux'
import {
  setUserEndDate,
  setUserLocation,
  setUserStartDate,
  setUsersType,
  setUserVisibility,
} from '../../../../../../redux/reducers/filter.slice'
const UsersListFilter = ({
  page,
  setPage,
  sDate,
  eDate,
  setSDate,
  setEDate,
  genderFilter,
  setGenderFilter,
  typeFilter,
  setTypeFilter,
  locationFilter,
  setLocationFilter,
  applyFilter,
  setApplyFilter,
}) => {
  const [startDate, setStartDate] = useState(sDate)

  const [endDate, setEndDate] = useState(eDate)

  const dispatch = useDispatch()
  const userFilter = useSelector((state) => state.filter.usersFilter)

  const [gender, setGender] = useState(genderFilter)

  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()
  const [role, setRole] = useState<string | undefined>()
  const [lastLogin, setLastLogin] = useState<string | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    // updateState({filter: undefined, ...initialQueryState})
    setGenderFilter('')

    dispatch(setUserStartDate(''))
    dispatch(setUserEndDate(''))
    dispatch(setUsersType(''))
    dispatch(setUserLocation(''))
    dispatch(setUserVisibility(''))

    setSDate('')
    setEDate('')
    setPage(1)
    setTypeFilter('')
    setLocationFilter('')
  }

  const filterData = () => {
    setApplyFilter(true)
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>

      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
        {/* begin::Header */}
        <div className='px-7 py-2'>
          <div className='fs-6 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-1' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div>
            <label className='form-label fs-6 fw-bold'>Users Type:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => dispatch(setUsersType(e.target.value))}
              value={userFilter.type}
            >
              <option value='' disabled={true}>
                User Type
              </option>
              <option value='CLIENT'>Client</option>
              <option value='INDIVIDUAL'>Individual</option>
              <option value='BUSINESS'>Business</option>
            </select>
          </div>

          <div>
            <label className='form-label fs-6 fw-bold'>Location:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => dispatch(setUserLocation(e.target.value))}
              value={userFilter.location}
            >
              <option value=''></option>
              <option value='San_Miguel_De_Allende'>San Miguel De Allende</option>
              <option value='Sayulita_Nay'>Sayulita</option>
              <option value='Puerto Escondido'>Puerto Escondido</option>
              <option value='Tulum'>Tulum</option>
            </select>
          </div>

          <div>
            <label className='form-label fs-6 fw-bold'>App Visibility:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => dispatch(setUserVisibility(e.target.value))}
              value={userFilter.visibility}
            >
              <option value=''>All</option>
              <option value='visible'>Visible in app</option>
              <option value='hidden'>Hidden from app</option>
            </select>
          </div>

          <div>
            <label className='form-label fs-6 fw-bold'>Start date:</label>
            <input
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={userFilter.startDate}
              max={new Date().toISOString().split('T')[0]}
              onChange={(e) => dispatch(setUserStartDate(e.target.value))}
            />
          </div>

          <div className='mb-2'>
            <label className='form-label fs-6 fw-bold'>End date:</label>
            <input
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={userFilter.endDate}
              max={new Date().toISOString().split('T')[0]}
              onChange={(e) => dispatch(setUserEndDate(e.target.value))}
            />
          </div>

          {/* end::Input group */}

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              // disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {UsersListFilter}
